/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycCompanyFormDto } from '../../models/kyc-company-form-dto';

export interface GetCompanyForm$Params {
  processId: string;
}

export function getCompanyForm(http: HttpClient, rootUrl: string, params: GetCompanyForm$Params, context?: HttpContext): Observable<StrictHttpResponse<KycCompanyFormDto>> {
  const rb = new RequestBuilder(rootUrl, getCompanyForm.PATH, 'get');
  if (params) {
    rb.path('processId', params.processId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycCompanyFormDto>;
    })
  );
}

getCompanyForm.PATH = '/kyc/processes/{processId}/company-form';
